import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/imacuser/Downloads/silk_export/src/app/about/components/AboutInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/imacuser/Downloads/silk_export/src/components/common/Header.tsx");
